import { useEffect } from "react";

const ptToEnMappings: Record<string, string> = {
  "/": "/en/",
  "/baixar-yango-pro-maputo": "/en/download-yango-pro-maputo",
  "/registo-yango-motorista-maputo": "/en/yango-driver-registration-maputo",
  "/requisitos-motorista-yango": "/en/yango-driver-requirements",
  "/cadastro-motorista-yango": "/en/yango-driver-signup",
  "/recarga-automatica-yango-pro-emola-mpesa": "/en/automatic-top-up-yango-pro",
  "/sobre-nos": "/en/about-us",
  "/blog": "/en/blog",
};

// PT-only pages (no EN version exists) - strip ?lang= and stay on PT
const ptOnlyPages: string[] = ["/documentacao"];

function normalizePath(pathname: string): string {
  if (pathname === "") return "/";
  return pathname.replace(/\/+$/, "") || "/";
}

export function useLegacyLanguageRedirect(): void {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const url = new URL(window.location.href);
    const lang = (url.searchParams.get("lang") || "").toLowerCase();

    if (lang !== "en" && lang !== "pt") return;

    const currentPath = normalizePath(url.pathname);
    url.searchParams.delete("lang");

    // lang=pt: strip query param, redirect to clean PT URL
    if (lang === "pt") {
      const clean = `${currentPath}${url.search || ""}${url.hash || ""}`;
      if (
        window.location.pathname === currentPath &&
        !new URLSearchParams(window.location.search).has("lang")
      ) {
        return;
      }
      window.location.replace(clean);
      return;
    }

    // lang=en: check if PT-only page (no EN version)
    if (ptOnlyPages.includes(currentPath)) {
      // Stay on PT, just strip the query param
      const clean = `${currentPath}${url.search || ""}${url.hash || ""}`;
      window.location.replace(clean);
      return;
    }

    // lang=en: map PT path to EN route
    const targetPath = ptToEnMappings[currentPath] || "/en/";
    const clean = `${targetPath}${url.search || ""}${url.hash || ""}`;
    window.location.replace(clean);
  }, []);
}
